export const PHONE_NUMBER_DISPLAY = "(01) 813 31 23";
export const PHONE_NUMBER_E164 = "+4318133123";
export const PHONE_NUMBER_TEL_LINK = `tel:${PHONE_NUMBER_E164}`;
export const WHATSAPP_LINK = "https://wa.me/4318133123";

/** Google Maps – Zahnarztordination Stella Dent S.L. */
export const GOOGLE_BUSINESS_PROFILE_URL =
	"https://www.google.com/maps/place/Zahnarztordination+Stella+Dent+S.L./@48.1829255,16.3255375,17z/data=!4m8!3m7!1s0x476da81114317f0d:0x4ada5151c1a3ccee!8m2!3d48.1829255!4d16.3255375!9m1!1b1!16s%2Fg%2F1vfp6_th?hl=de";

/** Öffnet das Google-Profil (dort „Rezension schreiben“). */
export const GOOGLE_REVIEW_URL = GOOGLE_BUSINESS_PROFILE_URL;
